const getNewCharacter = (wordRef, value) => {
  let newChar = '';
  for (let i = 0; i < wordRef.length + 1; i++) {
    if (wordRef[i] !== value[i]) {
      newChar = value[i];
      break;
    }
  }
  return newChar;
};

export { getNewCharacter };
//# sourceMappingURL=getNewCharacter.js.map
